import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';
import { produce } from 'immer';

import getProjectId from 'utils/url/getProjectId';
import getProjectState from 'store/getProjectState';
import setProjectState from 'store/setProjectState';

import { IProjectState } from 'store';
import IAsync from 'types/IAsync';
import ITaskDetails from 'types/ITaskDetails';

function setTaskDetailsAsync(projectId: string, taskId: string, taskDetailsAsync: IAsync<ITaskDetails>) {
  setProjectState(
    projectId,
    produce((state: IProjectState) => {
      state.taskDetailsAsyncMap[taskId] = taskDetailsAsync;
    }),
  );
}

export default function fetchTaskDetails(runId: string, taskId: string) {
  const projectId = getProjectId();
  if (!projectId) return;

  const async = getProjectState(store.getState(), projectId).taskDetailsAsyncMap[taskId] || { status: 'INIT' };

  switch (async.status) {
    case 'PENDING':
    case 'REFRESH':
      // Already fetching
      return;
    case 'INIT':
    case 'ERROR':
      setTaskDetailsAsync(projectId, taskId, { status: 'PENDING' });
      break;
    case 'SUCCESS':
      setTaskDetailsAsync(projectId, taskId, {
        status: 'REFRESH',
        data: async.data,
      });
      break;
  }

  api
    .get(`projects/${projectId}/workflows/${runId}/tasks/${taskId}`)
    .json()
    .then(
      (data) => {
        setTaskDetailsAsync(projectId, taskId, {
          status: 'SUCCESS',
          data: data as ITaskDetails,
        });
      },
      (error) => {
        Sentry.captureException(error);
        setTaskDetailsAsync(projectId, taskId, { status: 'ERROR' });
      },
    );
}
